// extracted by mini-css-extract-plugin
export default {"slideInDown":"styles_slideInDown__sb3Qw"};